import React, { useState, useEffect } from "react";
import PermissionChart from "../data/permissionChart";
import { useFormContext, useFieldArray } from "react-hook-form";
import { useTabContext } from "../context/context";
import { FaXmark, FaPlus } from "react-icons/fa6";

const Users = () => {
  const {
    register,
    setValue,
    control,
    watch,
    formState: { errors }
  } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    name: "users",
    control: control
  });

  const [isUserNew, setIsUserNew] = useState(false);
  const { userList } = useTabContext();
  const users = watch("users") || [];

  // Validate email for duplicates
  const validateEmail = (value, index) => {
    return !users.some((user, i) => user.email === value && i !== index) || "This email is already in use.";
  };

  // Initialize user list from context
  useEffect(() => {
    if (userList) {
      remove();
      userList.forEach(user => {
        const userActive = user.active === "1";
        append({
          member_id: user.member_id,
          email: user.email,
          role: user.role,
          active: userActive,
          new: false
        });
      });
    }
  }, [userList]);

  return (
    <div className="v3-db-tab-3">
      <div className="provider-section">
        <h3>User Management</h3>
        <h4 className="pt-2">
          Add additional users to help keep your availability updated.
          <br />
          Provide access to edit your profile by setting user roles below.
        </h4>

        <PermissionChart />

        <div className="mt-10 mx-auto w-full md:w-[80%] rounded-md grid grid-cols-1 shadow-md">
          {/* Header */}
          <div className="grid grid-cols-8 gap-4 border-2 border-gray-300 bg-gray-200">
            <div className="p-2 text-sm md:text-lg font-semibold flex items-center col-span-5">Email</div>
            <div className="p-2 text-sm md:text-lg font-semibold flex items-center justify-center col-span-2">Role</div>
            <div className="p-3 text-sm md:text-lg font-semibold md:flex items-center justify-center hidden">Remove</div>
          </div>

          {/* User Rows */}
          {fields.map((item, index) => (
            <div key={item.id} className="grid grid-cols-8 gap-4 border even:bg-gray-100">
              <div className="p-2 flex items-center col-span-5">
                <input
                  type="email"
                  {...register(`users[${index}].email`, {
                    validate: value => validateEmail(value, index)
                  })}
                  className="w-full rounded-md"
                  defaultValue={item.email}
                />
                {errors.users?.[index]?.email && <span className="text-red-500">{errors.users[index].email.message}</span>}
                <input type="hidden" {...register(`users[${index}].new`)} defaultValue={item.new} />
              </div>

              <div className="p-2 flex items-center justify-center col-span-2">
                <select {...register(`users[${index}].role`)} defaultValue={item.role}>
                  <option value="manager">Manager</option>
                  <option value="editor">Editor</option>
                  <option value="reporter">Reporter</option>
                </select>
              </div>

              <div className="p-2 flex items-center justify-center">
                <button onClick={() => remove(index)} className="text-red-500 hover:text-red-700 text-xl">
                  <FaXmark />
                </button>
              </div>
            </div>
          ))}

          {/* Add User Button */}
          <div className="mt-4 pb-4 pl-4">
            <div
              id="add_user"
              onClick={() =>
                append({
                  member_id: "",
                  email: "",
                  role: "",
                  active: false,
                  new: true
                })
              }
              className="border flex items-center border-primaryBlue text-white bg-primaryBlue rounded-md w-[125px] p-2 hover:cursor-pointer hover:bg-primaryBlue-80 hover:text-white"
            >
              <FaPlus className="text-lg mr-2" /> Add User
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Users;
